import React from "react";

const ButtonLoader = (props) => {
  return (
    <button className={`buttonload group relative flex items-center justify-between btn btn-red px-[10px]  text-white focus:outline-none ${props.className}`}>
      <span className="left-[20px] inset-y-0 flex items-center mx-[15px]">
        <i className="fa fa-spinner fa-spin text-white text-[17px]"></i>
      </span>
      <span className="mr-[15px] text-lg mobile-14">
        Loading
      </span>
    </button>
  );
};

export default ButtonLoader;
